import { NO_ERRORS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppFooterComponent } from './app-footer.component';
import { AppNgAppkitModule } from '../app-ng-appkit.module';

@NgModule({
  declarations: [AppFooterComponent],
  imports: [
    CommonModule,
    AppNgAppkitModule,
  ],
  exports: [AppFooterComponent],
  schemas: [NO_ERRORS_SCHEMA]
})
export class AppFooterModule { }
